// extracted by mini-css-extract-plugin
export default {"modalCont":"Share_modalCont__3bnUz","btnCont":"Share_btnCont__Xd+qz","close":"Share_close__LPduf","shareText":"Share_shareText__1mMRh"};